import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { glossaryRoute } from 'src/consts'

export type ListProps = {
  data?: object
}

export const List = ({ data }: ListProps) => {
  return (
    <div className={styles.container}>
      {Object.keys(data).map((key, index) => {
        return (
          data[key].length > 0 && (
            <div key={index} className={styles.items}>
              <div className={styles.leftColumn}>
                <div className={styles.leftIndex}>{key.toUpperCase()}</div>
              </div>
              <div className={styles.list}>
                {data[key].map((item: any, index: number) => (
                  <Link
                    key={index}
                    href={glossaryRoute({ slug: item.slug })}
                    legacyBehavior
                  >
                    <a className={styles.item}>
                      <div className={styles.title}>
                        {item.title}
                        <Image
                          src='/assets/icons/icon-green-arrow.svg'
                          width='30'
                          height='30'
                          alt='arrow icon'
                          className={styles.arrow}
                        />
                      </div>
                      <div className={styles.description}>
                        {item.shortPreview}
                      </div>
                    </a>
                  </Link>
                ))}
              </div>
            </div>
          )
        )
      })}
    </div>
  )
}
